module.exports = __webpack_public_path__ + "media/components/assets/img/logo/mono/mastercard-a001a2524ea85b08b8a4b3b06f067a6a.png";